import {getSearchQuery, isEmpty} from "../../utility";
import {getData, LOGIN} from "../../storage";

const width = 294;
const height = 164;

/**
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * API START * * * * * * * * * * * * * * * * * * * * * * * *
 */

const getContentListAPI = (props, content_type,filter_by, sort_by, pageCount, broadcasterId,only_subscribed_content = false) => {
    let page = pageCount ? pageCount : 1;
    const query = getSearchQuery();

    getData(LOGIN).then((data) => {
        if (!isEmpty(data) && data.api_token) {
            props.getHomeContent(
                data.token,
                data.api_token,
                query,
                filter_by.toLowerCase(),
                content_type.toLowerCase(),
                sort_by.toLowerCase(),
                page,
                width,
                height,
                broadcasterId,
                only_subscribed_content,
            );
        } else {
            //only run this if the searchQuery is blank
            props.getHomeContent(
                null,
                null,
                query,
                filter_by.toLowerCase(),
                content_type.toLowerCase(),
                sort_by.toLowerCase(),
                page,
                width,
                height,
                broadcasterId
            );
        }
    });
};

const getHistoryAPI = (props, filter_by, sort_by, pageCount) => {
    let page = pageCount ? pageCount : 1;
    getData(LOGIN).then((data) => {

        //token, api_token,width,height, filter_by, sort_by, page
        if (!isEmpty(data) && data.api_token) {
            props.getHistory(
                data.token,
                data.api_token,
                width,
                height,
                filter_by.toLowerCase(),
                sort_by.toLowerCase(),
                page
            );
        }
    });
};

const getVideoDetailsByIdAPI = (props,id) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getVideoDetailsById(
                    data.token,
                    data.api_token,
                    id
                );
            }else{
                props.getVideoDetailsById(
                    null,
                    null,
                    id
                );
            }
        })
}

const getPictureDetailsByIdAPI = (props,id) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getPictureDetailsById(
                    data.token,
                    data.api_token,
                    id
                );
            }else{
                props.getPictureDetailsById(
                    null,
                    null,
                    id
                );
            }
        })
}

const getGalleryDetailsByIdAPI = (props,id) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getGalleryDetailsById(
                    data.token,
                    data.api_token,
                    id
                );
            } else {
                props.getGalleryDetailsById(
                    null,
                    null,
                    id
                );
            }
        })
}

const purchaseContentAPI = (props, postData) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.purchaseContent(
                    data.token,
                    data.api_token,
                    postData
                );
            }
        })
}

const subscribeToBroadcasterAPI = (props, postData) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.subscribeToBroadcaster(
                    data.token,
                    data.api_token,
                    postData
                );
            }
        })
}

const getMyLibraryAPI = (props, request) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getMyLibrary(
                    data.token,
                    data.api_token,
                    request.width,
                    request.height,
                    request.searchValue,
                    request.sortBy,
                    request.page,
                );
            }
        })
}

export default {
    getContentListAPI,
    getHistoryAPI,
    getVideoDetailsByIdAPI,
    getPictureDetailsByIdAPI,

    getGalleryDetailsByIdAPI,
    getMyLibraryAPI,

    purchaseContentAPI,
    subscribeToBroadcasterAPI,
}